var map = {
	"./album_universal.png": 9181,
	"./arch_lintel.png": 5923,
	"./beam.png": 1927,
	"./bracket.png": 1468,
	"./burlap.png": 2408,
	"./caftan_basic.png": 1103,
	"./caftan_embroidered.png": 3410,
	"./caftan_grand.png": 8700,
	"./clean_scroll.png": 798,
	"./door.png": 8753,
	"./fence_panel.png": 4628,
	"./foundation_block.png": 4623,
	"./frame.png": 2832,
	"./handle.png": 3079,
	"./hinge.png": 6567,
	"./latch.png": 6182,
	"./nails.png": 7227,
	"./roof_bundle.png": 1292,
	"./roof_bundle_light.png": 1389,
	"./rope.png": 7148,
	"./small_frame.png": 2450,
	"./threshold.png": 5644,
	"./tile.png": 3409,
	"./wall_section.png": 8785,
	"./wall_section_corner.png": 4116,
	"./wall_section_door.png": 6954,
	"./wall_section_fence.png": 8611,
	"./wall_section_window.png": 4636,
	"./window_regular.png": 7952,
	"./window_small.png": 6617
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1523;